import Auth from './modules/auth.js'
import User from './modules/user.js'

export default [...Auth, ...User]
